import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { NoveltyCheckReportContext } from '../novelty-check-report-context';
import type { NoveltyCheckReportState } from '../novelty-check-report-state';
import { Logger } from '@patsnap/tahiti-core';
import { CurrentTaskService } from '@/services/current-task/current-task-service';
import { NoveltyCheckTaskStep } from '@/domains/novelty-check-report/enums';
import { RetrievalResultReportModel } from '@/domains/novelty-check-report/models/retrieval-result-report-model';
import { NoveltyCheckTaskCreator } from '../../novelty-check-task-creator';
import { NoveltyCheckTaskStatusModel } from '@/domains/novelty-check-report/models/novelty-check-task-status-model';

@injectable()
export class InitialState implements NoveltyCheckReportState {
    // eslint-disable-next-line max-params
    constructor(
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(RetrievalResultReportModel)
        private readonly _retrievalResultReportModel: RetrievalResultReportModel,
        @inject(NoveltyCheckTaskCreator)
        private readonly _noveltyCheckTaskCreator: NoveltyCheckTaskCreator,
        @inject(CurrentTaskService)
        private readonly _currentTaskService: CurrentTaskService,
        @inject(NoveltyCheckTaskStatusModel)
        private readonly _noveltyCheckTaskStatusModel: NoveltyCheckTaskStatusModel,
    ) { }

    async enter(): Promise<void> {
        // 初始状态进入逻辑
        this._logger.info('进入初始状态');
    }

    async handleNext(context: NoveltyCheckReportContext): Promise<void> {
        const text = this._retrievalResultReportModel.modelData.techEssential;
        const pbdStart = this._retrievalResultReportModel.modelData.pbdStart;
        const pbdEnd = this._retrievalResultReportModel.modelData.pbdEnd;
        await this._createTask({ text, pbdStart, pbdEnd });
        const summaryState = context.getState(NoveltyCheckTaskStep.SUMMARY);
        await context.transitionTo(summaryState);
        return;
    }

    async handlePrevious(): Promise<void> {
        // 初始状态没有上一步
        this._logger.info('初始状态没有上一步');
    }

    private get _isNewTask() {
        return this._noveltyCheckTaskStatusModel.modelData.taskStep === NoveltyCheckTaskStep.INITIAL;
    }

    private async _createTask(payload: {
        text: string;
        pbdStart?: string;
        pbdEnd?: string;
    }): Promise<void> {
        const taskId = this._currentTaskService.taskId;
        if (this._isNewTask) {
            await this._noveltyCheckTaskCreator.createTask({ text: payload.text, taskId, pbdStart: payload.pbdStart, pbdEnd: payload.pbdEnd });
        }
    }
}
